module.exports = __webpack_public_path__ + "img/assess.108ff9b.svg";